import gql from 'graphql-tag';

const POST_INSPECTION_FRAGMENT = gql`
  fragment PostInspectionFragment on PostInspection {
    title
    information_message
    min_price
    max_price
    price
  }
`;

export default POST_INSPECTION_FRAGMENT;
